/*!
 * LorenZone — Ma Collection V2 : bande « Ma Collection » des pages de série
 * ---------------------------------------------------------------------------
 * S'ajoute sous l'en-tête des traqueurs rzc-pkm / rzc-op / rzc-lor / rzc-nar
 * SANS les réécrire : elle lit l'état de la grille (cartes cochées, variantes
 * disponibles, prix) et réagit à l'événement « lz:mc:state » émis par les
 * traqueurs à chaque mise à jour.
 *
 * Ce qu'elle apporte (langage visuel de la page d'accueil 2026) :
 *  - anneau de progression, « il te manque X cartes, Y en stock pour Z € » ;
 *  - « Compléter la série » en 1 clic (version principale ; reverses et petit
 *    budget en puces à part) ;
 *  - puces « Cocher mes cartes », « En stock », « Manquantes », « Filtres » :
 *    elles pilotent les interrupteurs et le panneau des traqueurs, désormais
 *    masqués ; en mode cocher, chaque version devient une case et un bouton +
 *    sur le visuel coche toute la carte ;
 *  - recherche « n° ou nom » dans la série ;
 *  - visiteur non connecté : essai sans compte (collection locale), puis
 *    sauvegarde en se connectant ;
 *  - 🔔 « Préviens-moi » sur les versions en rupture (liste de souhaits) ;
 *  - pastille de verre quand la bande sort de l'écran ; point qui file vers le
 *    panier à chaque ajout.
 */
(function () {
  if (window.__LZMC_SERIES__) return;
  window.__LZMC_SERIES__ = true;

  var root = document.querySelector('.rzc-wrap[id^="rzc-"]');
  if (!root || !window.LZMC) return;

  var M = window.LZMC;
  var U = (root.dataset.lzUniverse || '').toLowerCase();
  var H = root.dataset.lzSeriesHandle || '';
  var ROUTES = window.LZ_MC_ROUTES || {};
  var ROOT_URL = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var REDUCED = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  // URL de connexion bien formée (l'existant ajoutait « ?return_url= » même si
  // l'adresse de connexion contenait déjà des paramètres). Le layout fournit
  // routes.storefront_login_url, qui porte déjà « return_to » (retour sur cette
  // page après connexion) : on ne la modifie alors pas.
  function withReturn(base) {
    try {
      var u = new URL(base, window.location.origin);
      if (u.searchParams.has('return_to')) return u.origin === window.location.origin ? u.pathname + u.search : u.href;
      u.searchParams.set('return_url', window.location.pathname + window.location.search);
      return u.origin === window.location.origin ? u.pathname + u.search : u.href;
    } catch (e) { return base; }
  }
  var LOGIN = withReturn(ROUTES.login || '/account/login');
  var REGISTER = withReturn(ROUTES.register || ROUTES.login || '/account/register');
  var SERIE = (function () {
    var h1 = root.querySelector('.rzc-header h1, .rzc-title');
    var t = (h1 && h1.textContent) || document.title || '';
    return t.replace(/\s*[|–-]\s*LorenZone.*$/i, '').replace(/\s*-\s*cartes.*$/i, '').trim();
  })();

  function api() { return window.lzApi; }
  function logged() {
    var a = api();
    if (!a) return false; // sans client d'API, aucun compte exploitable (e-mail factice des visiteurs)
    if (a.isLoggedIn) return a.isLoggedIn();
    return !!(root.dataset.lzCustomerEmail || '').trim();
  }

  // ---------------------------------------------------------------------------
  // Lecture de l'état de la grille
  // ---------------------------------------------------------------------------
  function priceCents(el) {
    if (!el) return 0;
    var n = parseFloat((el.textContent || '').replace(/[^\d,.]/g, '').replace(',', '.'));
    return Number.isFinite(n) ? Math.round(n * 100) : 0;
  }

  function readGrid() {
    var st = { total: 0, owned: 0, missing: 0, oos: 0, locked: 0, buy: [], buyCents: 0, cheap: [], cheapCents: 0, rev: { total: 0, owned: 0, buy: [], cents: 0 } };
    root.querySelectorAll('.rzc-item.lz-collection-item').forEach(function (li) {
      st.total++;
      var owned = li.classList.contains('lz-owned');
      var prim = null, rev = null, alt = null, locked = false;
      li.querySelectorAll('.rzc-var-form').forEach(function (f) {
        var input = f.querySelector('input[name="id"]');
        if (!input) return;
        var tg = f.querySelector('.lz-var-toggle-owned');
        var btn = f.querySelector('.rzc-var-btn');
        // Épuisé = classe is-disabled. « disabled » seul = fenêtre d'accès anticipé :
        // en stock mais réservé aux membres, donc ni achetable ni en rupture.
        var oos = !!btn && btn.classList.contains('is-disabled');
        var dis = !!btn && (btn.disabled || btn.dataset.lzmcDis === '1'); // « disabled » d'origine, même réactivé en mode cocher
        var info = {
          id: input.value,
          kind: (tg && tg.dataset.kind) || 'normal',
          price: priceCents(f.querySelector('.rzc-var-price')),
          buy: !!btn && !dis && !oos,
          locked: dis && !oos,
          owned: !!tg && tg.dataset.owned === 'true',
        };
        if (info.kind === 'reverse') { if (!rev) rev = info; }
        else {
          if (!prim) prim = info;
          if (!alt && info.buy) alt = info;
          if (info.locked) locked = true;
        }
      });
      if (owned) st.owned++;
      else {
        st.missing++;
        var target = prim && prim.buy ? prim : alt;
        if (target) {
          var row = { li: li, id: target.id, price: target.price };
          st.buy.push(row);
          st.buyCents += target.price;
          if (target.price <= 100) { st.cheap.push(row); st.cheapCents += target.price; }
        } else if (locked) st.locked++;
        else st.oos++;
      }
      if (rev) {
        st.rev.total++;
        if (rev.owned) st.rev.owned++;
        else if (rev.buy) { st.rev.buy.push({ li: li, id: rev.id, price: rev.price }); st.rev.cents += rev.price; }
      }
    });
    st.pct = st.total ? Math.round((st.owned / st.total) * 100) : 0;
    return st;
  }

  // ---------------------------------------------------------------------------
  // Rendu
  // ---------------------------------------------------------------------------
  var bar = document.createElement('section');
  bar.className = 'lzmc-bar';
  bar.setAttribute('aria-label', 'Ma Collection : ' + SERIE);
  bar.setAttribute('data-universe', U);
  // Seul le contenu (view) est redessiné : le champ de recherche reste en place,
  // sinon il perdrait le focus (et le clavier mobile se fermerait) à chaque rendu.
  var view = document.createElement('div');
  view.className = 'lzmc-bar__view';
  var find = document.createElement('div');
  find.className = 'lzmc-find';
  find.setAttribute('role', 'search');
  find.innerHTML = '<div class="lzmc-find__field">' +
    '<svg class="lzmc-find__icon" viewBox="0 0 24 24" aria-hidden="true" focusable="false"><circle cx="10.5" cy="10.5" r="6.5"/><path d="m15.5 15.5 5 5"/></svg>' +
    '<input type="search" class="lzmc-find__input" placeholder="N° ou nom de carte" aria-label="Chercher une carte de la série par numéro ou par nom" autocomplete="off" autocorrect="off" autocapitalize="off" spellcheck="false" enterkeyhint="search">' +
    '<button type="button" class="lzmc-find__clear" aria-label="Effacer la recherche" hidden><svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M7 7l10 10M17 7 7 17"/></svg></button>' +
    '</div><p class="lzmc-find__status" role="status"></p>';
  bar.appendChild(view);
  bar.appendChild(find);
  var anchor = root.querySelector('.rzc-header');
  if (anchor && anchor.parentNode) anchor.parentNode.insertBefore(bar, anchor.nextSibling);
  else root.insertBefore(bar, root.firstChild);

  var pill = document.createElement('div');
  pill.className = 'lzmc-pill';
  pill.setAttribute('role', 'group');
  pill.setAttribute('aria-label', 'Ma Collection');
  pill.hidden = true;
  pill.innerHTML = '<span class="lzmc-pill__ring" aria-hidden="true"></span>' +
    '<button type="button" class="lzmc-pill__txt" data-act="scroll"></button>' +
    '<button type="button" class="lzmc-pill__go" data-act="add-missing"></button>';
  document.body.appendChild(pill);
  var pillTxt = pill.querySelector('.lzmc-pill__txt');
  var pillGo = pill.querySelector('.lzmc-pill__go');
  var pillRing = pill.querySelector('.lzmc-pill__ring');

  var confirmTimer = null;
  var adding = null; // ajout groupé en cours : { act, inPill }
  var confirmInfo = null; // { act, inPill, n, cents } pendant les 5 s d'attente d'une confirmation
  var last = null;
  var shownPct = 0;

  function collectOn() { return root.classList.contains('lz-mode-collection'); }
  function missingOn() { var s = root.querySelector('.lz-missing-switch'); return !!s && s.dataset.on === '1'; }
  function availOn() { var s = root.querySelector('.lz-available-switch'); return !!s && s.dataset.on === '1'; }
  function hasFilters() { return !!root.querySelector('#lz-filter-trigger'); }

  // Anneau de progression : les chiffres défilent, l'arc se remplit.
  function ring(st) {
    var pct = st ? st.pct : 0;
    var full = st && st.total && st.missing === 0;
    return '<div class="lzmc-ring' + (full ? ' is-full' : '') + '" role="img" aria-label="' + (st ? st.pct + ' % : ' + M.plural(st.owned, 'carte', 'cartes') + ' sur ' + st.total : '') + '">' +
      '<svg viewBox="0 0 70 70" aria-hidden="true"><circle class="lzmc-ring__bg" cx="35" cy="35" r="29"/><circle class="lzmc-ring__fg" cx="35" cy="35" r="29" data-pct="' + pct + '"/></svg>' +
      '<div class="lzmc-ring__txt"><span class="lzmc-ring__pct" data-from="' + shownPct + '" data-to="' + pct + '">' + shownPct + ' %</span><small>' + (st ? st.owned + ' / ' + st.total : '') + '</small></div></div>';
  }
  function animateRing() {
    var fg = view.querySelector('.lzmc-ring__fg');
    var txt = view.querySelector('.lzmc-ring__pct');
    if (!fg || !txt) return;
    var to = Number(fg.dataset.pct) || 0, from = Number(txt.dataset.from) || 0;
    requestAnimationFrame(function () { fg.style.strokeDashoffset = String(182 - 182 * to / 100); });
    // Le texte est modifié dans son nœud existant (pas de re-rendu du DOM).
    function put(v) { if (txt.firstChild && txt.firstChild.nodeType === 3) txt.firstChild.data = v; else txt.textContent = v; }
    if (REDUCED || from === to) { put(to + ' %'); shownPct = to; return; }
    var t0 = performance.now(), d = 700;
    (function step(t) {
      var k = Math.min(1, (t - t0) / d); k = 1 - Math.pow(1 - k, 3);
      put(Math.round(from + (to - from) * k) + ' %');
      if (k < 1) requestAnimationFrame(step); else shownPct = to;
    })(t0);
  }
  function eyebrow(extra) {
    var dash = logged() ? '<a class="lzmc-bar__dash" href="' + ROOT_URL + 'pages/ma-collection">Mon tableau de bord <span aria-hidden="true">→</span></a>' : '';
    return '<div class="lzmc-eyebrow"><span class="lzmc-bar__brand">Ma Collection</span><span class="lzmc-bar__serie">' + M.esc(SERIE) + '</span>' + (extra || '') + dash + '</div>';
  }
  function chip(act, label, on, cls, attrs) {
    return '<button type="button" class="lzmc-chip' + (cls ? ' ' + cls : '') + '" data-act="' + act + '"' + (on != null ? ' aria-pressed="' + on + '"' : '') + (attrs ? ' ' + attrs : '') + '>' + label + '</button>';
  }
  function filtersChip() {
    return chip('filters', 'Filtres', null, '', 'aria-expanded="' + root.classList.contains('lz-filter-open') + '" aria-controls="lz-filter-panel"');
  }
  // Bouton du mode cocher : c'est lui qui déclenche toute la logique de Ma Collection,
  // il doit se voir. « hero » : action principale de la bande (rien de coché encore).
  function collectBtn(hero) {
    var on = collectOn();
    return '<button type="button" class="lzmc-collect' + (on ? ' is-on' : '') + (hero && !on ? ' lzmc-collect--hero' : '') + '" data-act="collect">' +
      '<span class="lzmc-collect__ico" aria-hidden="true">' + (on ? '✓' : '☑') + '</span>' +
      '<span class="lzmc-collect__txt"><b>' + (on ? 'Terminer' : 'Cocher mes cartes') + '</b>' +
      '<small>' + (on ? 'J’ai fini de cocher, retour aux achats' : 'Touche les cartes que tu as, on calcule ce qu’il te manque') + '</small></span></button>';
  }
  function toggles(st) {
    return chip('avail', 'En stock', availOn()) +
      chip('missing', 'Manquantes', missingOn()) +
      (hasFilters() ? filtersChip() : '');
  }
  function cta(act, label, cents) {
    return '<button type="button" class="lzmc-cta" data-act="' + act + '"><span class="lzmc-shine" aria-hidden="true"></span>' + label +
      (cents != null ? ' <span class="lzmc-cta__amt">· ' + M.money(cents) + '</span>' : '') + '</button>';
  }
  function hint() {
    return collectOn() ? '<p class="lzmc-hint">Touche (ou clique) une version pour la cocher, deux fois pour la retirer ; le + sur le visuel coche sa version principale. Pour acheter, quitte ce mode avec « Terminer ».</p>' : '';
  }

  function render() {
    var st = readGrid();
    last = st;
    if (confirmInfo) {
      var cur = confirmInfo.act === 'add-missing' ? [st.buy.length, st.buyCents] : confirmInfo.act === 'add-cheap' ? [st.cheap.length, st.cheapCents] : [st.rev.buy.length, st.rev.cents];
      if (cur[0] !== confirmInfo.n || cur[1] !== confirmInfo.cents) { confirmInfo = null; clearTimeout(confirmTimer); }
    }
    var isLogged = logged();
    var localCount = !isLogged && M.local ? Object.keys(M.local.get(U).products).length : 0;
    var html = '';
    var unavailable = api() && api().mode && api().mode() === 'unavailable';

    if (unavailable) {
      // Client connecté mais jeton absent (secret manquant côté boutique) : on ne
      // propose rien qui échouerait, on prévient. Les achats restent possibles.
      html = '<div class="lzmc-band__top"><div class="lzmc-band__txt">' + eyebrow() +
        '<div class="lzmc-band__big" role="heading" aria-level="2">Ma Collection est momentanément indisponible</div>' +
        '<div class="lzmc-band__sub">Tes cartes cochées ne sont pas perdues ; tu peux continuer tes achats normalement.</div></div></div>';
    } else if (!isLogged && localCount === 0 && !collectOn()) {
      // Visiteur qui n'a encore rien coché : la bande présente l'outil. Dès qu'il
      // active le mode cocher, il passe à l'état « commence ta collection ».
      var stock = st.buy.length ? '<b>' + M.plural(st.buy.length, 'carte en stock', 'cartes en stock') + '</b> dès ' + M.money(Math.min.apply(null, st.buy.map(function (r) { return r.price; })) || 0) + '. ' : '';
      html = '<div class="lzmc-band__top"><div class="lzmc-band__txt">' + eyebrow() +
        '<div class="lzmc-band__big" role="heading" aria-level="2">Suis ta collection gratuitement</div>' +
        '<div class="lzmc-band__sub">' + stock + 'Coche les cartes que tu possèdes : on te montre ce qu\'il te manque et tu complètes la série en un clic.</div></div></div>' +
        cta('collect', '<span aria-hidden="true">📒</span> Essayer maintenant, sans compte') +
        '<div class="lzmc-chips"><a class="lzmc-chip" href="' + M.esc(LOGIN) + '">Se connecter</a>' + chip('avail', 'En stock', availOn()) + (hasFilters() ? filtersChip() : '') + '</div>';
    } else if (st.owned === 0) {
      html = '<div class="lzmc-band__top">' + ring(st) + '<div class="lzmc-band__txt">' + eyebrow(isLogged ? '' : '<span class="lzmc-badge">Sur cet appareil</span>') +
        '<div class="lzmc-band__big" role="heading" aria-level="2">Commence ta collection ' + M.esc(SERIE) + '</div>' +
        '<div class="lzmc-band__sub">' + (collectOn() ? 'Touche ou clique les versions que tu possèdes : ta progression et tes cartes manquantes s\'afficheront ici.' : 'Active « Cocher mes cartes », puis touche ou clique les versions que tu possèdes. Ta progression et tes cartes manquantes s\'afficheront ici.') + '</div></div></div>' +
        '<div class="lzmc-collect-row">' + collectBtn(true) + '</div>' +
        '<div class="lzmc-chips">' + toggles(st) + '</div>' + hint();
    } else if (st.missing === 0) {
      var revMsg = st.rev.total && st.rev.owned < st.rev.total
        ? 'Il te reste <b>' + M.plural(st.rev.total - st.rev.owned, 'reverse', 'reverses') + '</b> pour le master set' + (st.rev.buy.length ? ', dont ' + st.rev.buy.length + ' en stock (' + M.money(st.rev.cents) + ').' : '.')
        : 'Tu as toutes les cartes de cette série.';
      html = '<div class="lzmc-band__top">' + ring(st) + '<div class="lzmc-band__txt">' + eyebrow('<span class="lzmc-badge lzmc-badge--gold"><span aria-hidden="true">🏆</span> Série complète</span>') +
        '<div class="lzmc-band__big" role="heading" aria-level="2">Bravo, série complète !</div><div class="lzmc-band__sub">' + revMsg + '</div></div>' +
        (st.rev.buy.length ? cta('add-rev', 'Ajouter les ' + st.rev.buy.length + ' reverses', st.rev.cents) : '') + '</div>' +
        '<div class="lzmc-collect-row">' + collectBtn(false) + '</div>' +
        '<div class="lzmc-chips">' + toggles(st) + '<a class="lzmc-chip" href="' + ROOT_URL + 'pages/ma-collection">Mes autres séries</a></div>' + hint();
    } else {
      var sub = '';
      if (st.buy.length) sub += '<b>' + st.buy.length + ' en stock</b> pour ' + M.money(st.buyCents);
      if (st.oos) sub += (sub ? ' · ' : '') + st.oos + ' en rupture' + (st.buy.length ? '' : ' (active la cloche <span aria-hidden="true">🔔</span> pour être prévenu de leur retour)' );
      if (st.locked) sub += (sub ? ' · ' : '') + st.locked + (st.locked > 1 ? ' réservées' : ' réservée') + ' aux membres pour l’instant';
      html = '<div class="lzmc-band__top">' + ring(st) + '<div class="lzmc-band__txt">' + eyebrow(isLogged ? '' : '<span class="lzmc-badge">Sur cet appareil</span>') +
        '<div class="lzmc-band__big" role="heading" aria-level="2">Il te manque ' + M.plural(st.missing, 'carte', 'cartes') + '</div>' +
        '<div class="lzmc-band__sub">' + sub + '</div></div>' +
        (st.buy.length ? cta('add-missing', 'Compléter la série', st.buyCents) : '') + '</div>' +
        '<div class="lzmc-collect-row">' + collectBtn(false) + '</div>' +
        '<div class="lzmc-chips">' + toggles(st) +
        (st.cheap.length && st.cheap.length < st.buy.length ? chip('add-cheap', 'Petit budget : ' + M.plural(st.cheap.length, 'carte', 'cartes') + ' à 1 € max · ' + M.money(st.cheapCents), null, 'lzmc-chip--buy') : '') +
        (st.rev.buy.length ? chip('add-rev', '+ ' + st.rev.buy.length + ' reverses · ' + M.money(st.rev.cents), null, 'lzmc-chip--buy') : '') +
        '</div>' + hint() +
        (!isLogged
          ? '<p class="lzmc-bar__save"><span aria-hidden="true">💾</span> ' + (localCount > 1 ? 'Tes ' + localCount + ' cartes cochées sont gardées' : 'Ta carte cochée est gardée') + ' sur cet appareil. <a href="' + M.esc(LOGIN) + '">Connecte-toi</a> ou <a href="' + M.esc(REGISTER) + '">crée ton compte</a> pour ' + (localCount > 1 ? 'les sauvegarder et les retrouver' : 'la sauvegarder et la retrouver') + ' partout.</p>'
          : '');
    }
    var ae = document.activeElement, keep = null, keepHref = null;
    if (ae && view.contains(ae)) { keep = ae.getAttribute('data-act'); if (!keep) keepHref = ae.getAttribute('href'); }
    view.innerHTML = html;
    var again = keep ? view.querySelector('[data-act="' + keep + '"]') : keepHref ? [].filter.call(view.querySelectorAll('a[href]'), function (a) { return a.getAttribute('href') === keepHref; })[0] : null;
    if (again) again.focus({ preventScroll: true });
    if (adding && !adding.inPill) reapplyBusy(view.querySelector('[data-act="' + adding.act + '"]'));
    if (confirmInfo && !confirmInfo.inPill) reapplyConfirm(view.querySelector('[data-act="' + confirmInfo.act + '"]'));
    animateRing();
    renderPill(st);
    injectPicks();
    syncCollect();
  }

  function renderPill(st) {
    var show = !!st && st.buy.length > 0 && (logged() || (M.local && Object.keys(M.local.get(U).products).length > 0));
    pill.dataset.show = show ? '1' : '0';
    if (!show) { pill.hidden = true; return; }
    pillRing.style.setProperty('--p', st.pct + '%');
    pillTxt.textContent = st.owned + ' / ' + st.total;
    pillTxt.setAttribute('aria-label', st.owned + ' / ' + st.total + ' cartes, revenir au résumé Ma Collection');
    // Le bouton est un nœud persistant : on le remet à neutre avant d'écrire son texte.
    pillGo.disabled = false;
    pillGo.classList.remove('is-confirm', 'is-loading');
    delete pillGo.dataset.confirm;
    delete pillGo.dataset.label;
    pillGo.innerHTML = 'Compléter · ' + M.money(st.buyCents) + '<span class="lzmc-sr"> : ajouter ' + M.plural(st.buy.length, 'carte manquante', 'cartes manquantes') + ' au panier</span>';
    reapplyConfirm(pillGo);
    reapplyBusy(pillGo);
    updatePillVisibility();
  }

  var barVisible = true;
  if ('IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      barVisible = entries[0].isIntersecting;
      updatePillVisibility();
    }, { threshold: 0 }).observe(bar);
  }
  function updatePillVisibility() {
    pill.hidden = !(pill.dataset.show === '1' && !barVisible && !root.classList.contains('lz-fab-open') && !root.classList.contains('lz-filter-open'));
  }
  pill.addEventListener('click', function (e) {
    var b = e.target.closest('[data-act]');
    if (!b) return;
    if (b.dataset.act === 'scroll') {
      bar.scrollIntoView({ behavior: REDUCED ? 'auto' : 'smooth', block: 'center' });
      M.track('bar_open', { universe: U, series_handle: H, source: 'series_bar' });
    } else if (b.dataset.act === 'add-missing' && last) addRows(last.buy, last.buyCents, b, 'manquantes', 'cart_add_bulk');
  });

  // ---------------------------------------------------------------------------
  // Point qui file vers le panier (Web Animations ; rien si mouvement réduit)
  // ---------------------------------------------------------------------------
  function flyToCart(from) {
    if (REDUCED || !from || !from.getBoundingClientRect || !document.body.animate) return;
    var target = document.querySelector('#cart-icon-bubble, .header__icon--cart, a[href$="/cart"]');
    if (!target) return;
    var a = from.getBoundingClientRect(), b = target.getBoundingClientRect();
    if (!a.width || !b.width) return;
    var dot = document.createElement('span');
    dot.className = 'lzmc-fly';
    dot.style.left = (a.left + a.width / 2 - 6) + 'px';
    dot.style.top = (a.top + a.height / 2 - 6) + 'px';
    document.body.appendChild(dot);
    var anim = dot.animate([
      { transform: 'translate(0,0) scale(1)', opacity: 1 },
      { transform: 'translate(' + (b.left + b.width / 2 - a.left - a.width / 2) + 'px,' + (b.top + b.height / 2 - a.top - a.height / 2) + 'px) scale(.4)', opacity: .6 },
    ], { duration: 650, easing: 'cubic-bezier(.22,.61,.36,1)' });
    anim.onfinish = function () { dot.remove(); };
    setTimeout(function () { if (dot.parentNode) dot.remove(); }, 1200);
  }

  // ---------------------------------------------------------------------------
  // Recherche « n° ou nom » (constat UX-10 : sur mobile, une carte précise
  // était jusqu'à 14 écrans plus bas). Sans accents ni casse ; un nombre seul
  // (« 12 ») désigne la carte n° 12 (« 012/165 », « OP15-012 »…). Elle masque
  // par sa propre classe : les filtres des traqueurs (manquantes, en stock,
  // panneau « Filtres ») continuent de s'appliquer en plus, sans être touchés.
  // ---------------------------------------------------------------------------
  var FIND_HIDE = 'lzmc-find-hide';
  var TRACKER_HIDE = ['is-filter-mode', 'is-filter-pill', 'lz-filter-hidden'];
  var findInput = find.querySelector('.lzmc-find__input');
  var findClear = find.querySelector('.lzmc-find__clear');
  var findStatus = find.querySelector('.lzmc-find__status');
  var findKeys = new WeakMap();
  var findTimer = null;

  function fold(s) {
    return String(s || '').normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase()
      .replace(/œ/g, 'oe').replace(/æ/g, 'ae').replace(/[^a-z0-9]+/g, ' ').trim();
  }
  function isNum(s) { return /^\d+$/.test(s); }
  function findOn() { return !!fold(findInput.value); }

  // Clé de recherche d'une carte (« 012/165 - Pikachu ex »), calculée une fois.
  function cardKey(li) {
    var k = findKeys.get(li);
    if (k) return k;
    var title = li.dataset.productTitle || '';
    var cut = title.indexOf(' - ');
    var code = li.dataset.cardCode || (cut > 0 ? title.slice(0, cut) : '');
    var num = code.split('/')[0].match(/(\d+)\D*$/); // « OP15-012 » → 12, « TG12/TG30 » → 12
    var text = fold(title);
    k = {
      text: text,
      words: text.split(' '),
      name: fold(cut > 0 ? title.slice(cut + 3) : title).replace(/ /g, ''),
      num: num ? parseInt(num[1], 10) : -1,
    };
    findKeys.set(li, k);
    return k;
  }

  function findTest(q) {
    var f = fold(q);
    if (!f) return null;
    var one = f.match(/^(?:n|no|num|numero)? ?(\d+)$/); // « 12 », « n° 12 », « #12 »
    if (one) {
      var n = parseInt(one[1], 10);
      return function (k) { return k.num === n; };
    }
    var toks = f.split(' ');
    var flat = f.replace(/ /g, '');
    return function (k) {
      if (k.name.indexOf(flat) >= 0) return true; // « hooh » → Ho-Oh, « porygon 2 » → Porygon2
      return toks.every(function (t) {
        if (!isNum(t)) return k.text.indexOf(t) >= 0;
        var n = +t; // « op15 12 », « 012/165 » : nombres entiers, pas « 112 » ni « 120 »
        return k.num === n || k.words.some(function (w) { return isNum(w) && +w === n; });
      });
    };
  }

  function applySearch() {
    clearTimeout(findTimer);
    var test = findTest(findInput.value);
    var shown = 0, masked = 0;
    root.querySelectorAll('.rzc-item').forEach(function (li) {
      var ok = !test || test(cardKey(li));
      if (li.classList.contains(FIND_HIDE) === ok) li.classList.toggle(FIND_HIDE, !ok);
      if (!test || !ok) return;
      if (TRACKER_HIDE.some(function (c) { return li.classList.contains(c); })) masked++;
      else shown++;
    });
    var msg = '';
    if (test) {
      if (shown) msg = M.plural(shown, 'carte trouvée', 'cartes trouvées') + (masked ? ' · ' + M.plural(masked, 'autre masquée', 'autres masquées') + ' par tes filtres' : '');
      else if (masked) msg = M.plural(masked, 'carte correspond, masquée', 'cartes correspondent, masquées') + ' par tes filtres';
      else msg = 'Aucune carte ne correspond dans cette série';
    }
    findClear.hidden = !findInput.value;
    find.classList.toggle('is-none', !!test && !shown);
    if (findStatus.textContent !== msg) findStatus.textContent = msg;
  }

  findInput.addEventListener('input', function () {
    findClear.hidden = !findInput.value;
    clearTimeout(findTimer);
    findTimer = setTimeout(applySearch, 150);
  });
  findInput.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' && !e.isComposing) {
      e.preventDefault();
      applySearch();
      // Ferme le clavier des mobiles pour laisser voir les cartes trouvées.
      if (window.matchMedia && window.matchMedia('(pointer: coarse)').matches) findInput.blur();
    } else if (e.key === 'Escape' && findInput.value) {
      findInput.value = '';
      applySearch();
    }
  });
  findClear.addEventListener('click', function () {
    findInput.value = '';
    applySearch();
    findInput.focus();
  });

  // ---------------------------------------------------------------------------
  // Actions
  // ---------------------------------------------------------------------------
  function clickSwitch(sel) {
    var sw = root.querySelector(sel);
    if (sw) sw.click();
  }

  function armConfirm(btn) {
    btn.dataset.confirm = '1';
    btn.dataset.label = btn.textContent;
    btn.textContent = 'Confirmer : ' + confirmInfo.n + ' cartes · ' + M.money(confirmInfo.cents) + ' ✓';
    btn.classList.add('is-confirm');
  }
  // Après un rendu (les boutons de la bande sont reconstruits), le bouton qui
  // attendait une confirmation la réaffiche au lieu de la perdre.
  function reapplyConfirm(btn) {
    if (!confirmInfo || !btn || btn.dataset.act !== confirmInfo.act || pill.contains(btn) !== confirmInfo.inPill) return;
    armConfirm(btn);
  }

  function addRows(rows, cents, btn, label, eventName) {
    if (!rows.length) return;
    // Confirmation en deux temps au-delà de 10 cartes (évite l'ajout par erreur).
    if (adding) return; // un ajout est déjà en cours : pas de double ajout
    var same = !!confirmInfo && !!btn && confirmInfo.act === btn.dataset.act && confirmInfo.inPill === pill.contains(btn) && confirmInfo.n === rows.length && confirmInfo.cents === cents;
    if (rows.length > 10 && btn && !(btn.dataset.confirm === '1' && same)) {
      confirmInfo = { act: btn.dataset.act, inPill: pill.contains(btn), n: rows.length, cents: cents };
      armConfirm(btn);
      clearTimeout(confirmTimer);
      confirmTimer = setTimeout(function () { confirmInfo = null; render(); }, 12000);
      return;
    }
    clearTimeout(confirmTimer);
    confirmInfo = null;
    if (btn) { btn.disabled = true; btn.classList.add('is-loading'); btn.textContent = 'Ajout en cours…'; }
    adding = { act: btn && btn.dataset.act, inPill: !!btn && pill.contains(btn) };
    flyToCart(btn);
    M.addToCart(rows.map(function (r) { return { id: r.id }; }), 'mc-bar').then(function (res) {
      if (res.added) M.toast('✅ ' + M.plural(res.added, 'carte ajoutée', 'cartes ajoutées') + ' au panier', 'ok');
      if (res.failed.length) M.toast((res.added ? M.plural(res.added, 'carte ajoutée', 'cartes ajoutées') + ', ' : '') + M.plural(res.failed.length, 'carte n’est plus disponible', 'cartes ne sont plus disponibles'), 'warn');
      M.track(eventName, { universe: U, series_handle: H, items: res.added, value_cents: cents, source: 'series_bar', meta: { label: label } });
    }).catch(function () {
      M.toast('Erreur d\'ajout au panier, réessaie', 'error');
    }).then(function () { adding = null; render(); });
  }
  function reapplyBusy(b) {
    if (!adding || !b || b.dataset.act !== adding.act || pill.contains(b) !== adding.inPill) return;
    b.disabled = true; b.classList.add('is-loading'); b.textContent = 'Ajout en cours…';
  }

  bar.addEventListener('click', function (e) {
    var b = e.target.closest('[data-act]');
    if (!b) return;
    var act = b.dataset.act;
    if (act === 'collect') {
      clickSwitch('.lz-collection-switch');
      setTimeout(render, 50);
    } else if (act === 'avail') {
      clickSwitch('.lz-available-switch');
      setTimeout(render, 50);
    } else if (act === 'missing') {
      clickSwitch('.lz-missing-switch');
      M.track('filter_missing', { universe: U, series_handle: H, source: 'series_bar' });
      setTimeout(render, 50);
    } else if (act === 'filters') {
      var t = root.querySelector('#lz-filter-trigger');
      if (t) { t.click(); setTimeout(function () { var c = root.querySelector('#lz-filter-close'); if (root.classList.contains('lz-filter-open') && c) c.focus({ preventScroll: true }); }, 60); }
    } else if (act === 'add-missing' && last) addRows(last.buy, last.buyCents, b, 'manquantes', 'cart_add_bulk');
    else if (act === 'add-cheap' && last) addRows(last.cheap, last.cheapCents, b, 'petit-budget', 'cart_add_bulk');
    else if (act === 'add-rev' && last) addRows(last.rev.buy, last.rev.cents, b, 'reverses', 'cart_add_bulk');
  });

  // ---------------------------------------------------------------------------
  // Boutons prix de la grille
  //  - mode achat : ajout au panier AVANT le traqueur (phase de capture) pour
  //    ouvrir la notification panier du thème, tracer l'ajout (« mc-card »),
  //    passer le bouton au vert et faire filer un point vers le panier ;
  //  - mode cocher : la ligne devient une case ; on actionne le ➕ natif (masqué)
  //    de la même version, qui enregistre côté serveur comme avant.
  // Sans JavaScript, le formulaire classique /cart/add reste fonctionnel.
  // ---------------------------------------------------------------------------
  function toggleOf(form) { return form.querySelector('.lz-var-toggle-owned'); }

  // Relaie un tap au ➕ natif (masqué). Sur une version déjà cochée, le traqueur
  // arme d'abord la suppression (➖, deux temps) : on la désarme après 4 s pour
  // qu'une ligne armée par erreur ne se décoche pas d'un seul tap plus tard.
  var disarmTimers = new WeakMap();
  function relay(tg) {
    if (!tg) return;
    var snap = { text: tg.textContent, cls: tg.className, title: tg.title, label: tg.getAttribute('aria-label') };
    tg.click();
    clearTimeout(disarmTimers.get(tg));
    if (tg.dataset.confirmRemove !== '1') return;
    disarmTimers.set(tg, setTimeout(function () {
      if (tg.dataset.confirmRemove !== '1') return;
      tg.dataset.confirmRemove = '0';
      tg.textContent = snap.text; tg.className = snap.cls; tg.title = snap.title;
      if (snap.label == null) tg.removeAttribute('aria-label'); else tg.setAttribute('aria-label', snap.label);
    }, 4000));
  }

  document.addEventListener('submit', function (e) {
    var form = e.target && e.target.closest ? e.target.closest('.rzc-var-form') : null;
    if (!form || !root.contains(form)) return;
    e.preventDefault();
    e.stopPropagation();
    var btn = form.querySelector('.rzc-var-btn');
    var input = form.querySelector('input[name="id"]');
    if (!btn || !input) return;
    if (collectOn()) {
      var tg = toggleOf(form);
      relay(tg);
      return;
    }
    // data-lzmc-dis : bouton désactivé à l'origine, encore réactivé juste après la sortie du mode cocher.
    if (btn.disabled || btn.dataset.lzmcDis === '1' || btn.classList.contains('is-disabled')) return;
    if (btn.dataset.lzmcBusy === '1') return; // double clic : un seul ajout
    btn.dataset.lzmcBusy = '1';
    btn.classList.add('is-loading');
    var li = form.closest('.rzc-item');
    var price = priceCents(form.querySelector('.rzc-var-price'));
    flyToCart(btn);
    M.addToCart([{ id: input.value }], 'mc-card').then(function (res) {
      if (res.added) {
        btn.classList.add('is-added');
        setTimeout(function () { btn.classList.remove('is-added'); }, 2600);
        if (!document.querySelector('cart-notification, cart-drawer')) {
          M.toast('✅ Ajoutée au panier', 'ok', { href: ROOT_URL + 'cart', label: 'Voir le panier' });
        }
        var meta = { owned: !!(li && li.classList.contains('lz-owned')) };
        if (findOn()) meta.search = true; // carte trouvée par la recherche (mesure UX-10)
        M.track('cart_add', { universe: U, series_handle: H, items: 1, value_cents: price, source: 'series_card', meta: meta });
      } else {
        M.toast('Cette carte n’est plus disponible', 'warn');
      }
    }).catch(function () {
      M.toast('Erreur d’ajout au panier, réessaie', 'error');
    }).then(function () {
      btn.dataset.lzmcBusy = '';
      btn.classList.remove('is-loading');
    });
  }, true);

  // En mode cocher, un bouton épuisé (désactivé, il n'envoie pas de submit) coche
  // aussi sa version ; et le « + » posé sur le visuel coche la version principale.
  root.addEventListener('click', function (e) {
    var pick = e.target.closest('.lzmc-pick');
    if (pick) {
      e.preventDefault();
      e.stopPropagation();
      var li = pick.closest('.rzc-item');
      var forms = li ? Array.prototype.slice.call(li.querySelectorAll('.rzc-var-form')) : [];
      var main = forms.find(function (f) { var tg = toggleOf(f); return tg && tg.dataset.kind !== 'reverse'; }) || forms[0];
      var tg = main && toggleOf(main);
      relay(tg);
      return;
    }
    if (!collectOn()) return;
    // Le clic que nous envoyons au ➕ natif remonte jusqu'ici : on le laisse passer.
    if (e.target.closest('.lz-var-toggle-owned')) return;
    // Un bouton désactivé n'émet pas de clic : en mode cocher, le CSS le rend
    // transparent aux pointeurs et c'est la ligne (.rzc-var-form) qui reçoit le clic.
    var form = e.target.closest('.rzc-var-form');
    if (!form || !root.contains(form)) return;
    var btn = form.querySelector('.rzc-var-btn');
    if (!btn || !(btn.disabled || btn.classList.contains('is-disabled'))) return;
    var tg2 = toggleOf(form);
    if (tg2) { e.preventDefault(); e.stopPropagation(); relay(tg2); }
  }, true);

  // Mode cocher : les boutons désactivés (épuisés, accès anticipé) redeviennent
  // focalisables (clavier, Firefox) et portent l'état coché ; en mode achat tout revient.
  function syncCollect() {
    var on = collectOn();
    root.querySelectorAll('.rzc-var-form').forEach(function (f) {
      var b = f.querySelector('.rzc-var-btn');
      if (!b) return;
      if (on) {
        if (b.disabled) { b.disabled = false; b.dataset.lzmcDis = '1'; b.setAttribute('aria-disabled', 'false'); }
        var tg = toggleOf(f);
        if (tg) b.setAttribute('aria-pressed', tg.dataset.owned === 'true' ? 'true' : 'false');
      } else {
        if (b.dataset.lzmcDis === '1') { b.disabled = true; b.setAttribute('aria-disabled', 'true'); delete b.dataset.lzmcDis; }
        if (b.hasAttribute('aria-pressed')) b.removeAttribute('aria-pressed');
      }
    });
  }

  function injectPicks() {
    root.querySelectorAll('.rzc-item.lz-collection-item .rzc-thumb').forEach(function (thumb) {
      var b = thumb.querySelector('.lzmc-pick');
      if (!b) {
        b = document.createElement('button');
        b.type = 'button';
        b.className = 'lzmc-pick';
        thumb.appendChild(b);
      }
      var li = thumb.closest('.rzc-item');
      var owned = !!li && li.classList.contains('lz-owned');
      var txt = owned ? '✓' : '+';
      if (b.textContent !== txt) b.textContent = txt;
      var name = (li && li.dataset.productTitle) || 'cette carte';
      b.setAttribute('aria-label', 'Cocher ' + name);
      b.title = owned ? 'Touche deux fois pour la retirer de ta collection' : 'Cocher cette carte';
      b.setAttribute('aria-pressed', owned ? 'true' : 'false');
    });
  }

  // ---------------------------------------------------------------------------
  // 🔔 « Préviens-moi » sur les versions en rupture des cartes non possédées
  // ---------------------------------------------------------------------------
  var wished = new Set();
  var wishLoaded = false;

  function injectBells() {
    root.querySelectorAll('.rzc-item.lz-collection-item').forEach(function (li) {
      li.querySelectorAll('.rzc-var-form').forEach(function (f) {
        var btn = f.querySelector('.rzc-var-btn');
        var input = f.querySelector('input[name="id"]');
        if (!btn || !input) return;
        var unavailable = btn.classList.contains('is-disabled'); // jamais sur un simple « disabled » (accès anticipé : la carte est en stock)
        var bell = f.querySelector('.lzmc-bell');
        if (!unavailable) { if (bell) bell.remove(); return; }
        if (!bell) {
          bell = document.createElement('button');
          bell.type = 'button';
          bell.className = 'lzmc-bell';
          bell.dataset.vid = input.value;
          var tg = f.querySelector('.lz-var-toggle-owned');
          bell.dataset.kind = (tg && tg.dataset.kind) || 'normal';
          f.appendChild(bell);
        }
        var on = wished.has(input.value);
        bell.classList.toggle('is-on', on);
        bell.setAttribute('aria-pressed', on ? 'true' : 'false');
        var vt = btn.querySelector('.rzc-var-title'); var vname = vt && vt.textContent.trim() ? 'la version « ' + vt.textContent.trim() + ' »' : 'cette version';
        bell.setAttribute('aria-label', on ? 'Alerte activée pour ' + vname + ' : touche pour la retirer' : 'Préviens-moi quand ' + vname + ' revient en stock');
        bell.title = on ? 'Alerte activée' : 'Préviens-moi au retour en stock';
        bell.textContent = '🔔';
      });
    });
  }

  function loadWishlist() {
    if (wishLoaded || !logged()) return Promise.resolve();
    wishLoaded = true;
    return api().wishlistList({ universe: U }).then(function (r) {
      if (r && r.ok) (r.data.wishlist || []).forEach(function (w) { wished.add(String(w.shopify_variant_id)); });
      injectBells();
    });
  }

  root.addEventListener('click', function (e) {
    var bell = e.target.closest('.lzmc-bell');
    if (!bell) return;
    e.preventDefault();
    e.stopPropagation();
    if (!api()) { M.toast('Service indisponible pour l’instant, réessaie plus tard', 'warn'); return; }
    if (!logged()) {
      M.toast('Connecte-toi pour suivre le retour en stock de cette version', 'warn', { href: LOGIN, label: 'Se connecter' });
      return;
    }
    var vid = bell.dataset.vid;
    var li = bell.closest('.rzc-item');
    var on = wished.has(vid);
    (on ? wished.delete(vid) : wished.add(vid));
    injectBells();
    var call = on
      ? api().wishlistRemove({ variantId: vid })
      : api().wishlistAdd({
          universe: U, variantId: vid, productId: li ? li.dataset.productId : '',
          variantKind: bell.dataset.kind, seriesHandle: H, productTitle: li ? li.dataset.productTitle : '',
        });
    call.then(function (r) {
      if (!r || !r.ok) { (on ? wished.add(vid) : wished.delete(vid)); injectBells(); M.toast('Impossible d\'enregistrer l\'alerte', 'error'); return; }
      var cardLink = li && li.querySelector('a.rzc-card');
      var mailLink = null;
      if (!on && cardLink && cardLink.getAttribute('href')) {
        // L'application de réassort de la boutique (Kbite) propose l'alerte par
        // e-mail sur la fiche produit, avec son propre consentement.
        var u = cardLink.getAttribute('href');
        mailLink = { href: u + (u.indexOf('?') >= 0 ? '&' : '?') + 'variant=' + encodeURIComponent(vid), label: 'Être aussi prévenu par e-mail →' };
      }
      M.toast(on ? 'Alerte retirée' : '🔔 Noté ! Cette carte apparaîtra dans « Ma Collection » dès son retour.', on ? '' : 'ok', mailLink);
      M.track(on ? 'wishlist_remove' : 'wishlist_add', { universe: U, series_handle: H, items: 1, source: 'series_card' });
    });
  }, true);

  // ---------------------------------------------------------------------------
  // Import de la collection locale après connexion
  // ---------------------------------------------------------------------------
  function offerImport() {
    if (!logged() || !M.local || M.local.count() === 0) return;
    var n = M.local.count();
    var box = document.createElement('div');
    box.className = 'lzmc-import';
    box.innerHTML = '<p><b>' + M.plural(n, 'carte cochée', 'cartes cochées') + '</b> avant ta connexion sur cet appareil. On les ajoute à ta collection ?</p>' +
      '<div class="lzmc-bar__actions"><button type="button" class="lzmc-btn lzmc-btn--primary" data-imp="yes">Oui, les ajouter</button>' +
      '<button type="button" class="lzmc-btn lzmc-btn--ghost" data-imp="no">Non, les oublier</button></div>';
    bar.parentNode.insertBefore(box, bar);
    box.addEventListener('click', function (e) {
      var b = e.target.closest('[data-imp]');
      if (!b) return;
      if (b.dataset.imp === 'no') { M.local.clear(); box.remove(); return; }
      b.disabled = true; b.textContent = 'Ajout en cours…';
      var fail = function () { b.disabled = false; b.textContent = 'Oui, les ajouter'; M.toast('Import impossible pour l’instant, réessaie', 'error'); };
      M.importLocal().then(function (r) {
        if (!r || !r.imported) { fail(); return; }
        box.remove();
        M.toast('✅ ' + M.plural(r.imported, 'carte importée', 'cartes importées') + ' — recharge en cours', 'ok');
        setTimeout(function () { window.location.reload(); }, 1200);
      }).catch(fail);
    });
  }

  // ---------------------------------------------------------------------------
  // Démarrage
  // ---------------------------------------------------------------------------
  // Les collectionneurs de la série arrivent directement en mode cocher (constat
  // PS-22 : les ➕ étaient cachés derrière le panneau flottant). Le choix de
  // l'utilisateur est mémorisé s'il quitte le mode depuis la bande.
  var PREF_KEY = 'lzmc:collect:off';
  var autoCollectDone = false;
  function autoCollect() {
    if (autoCollectDone || !last || last.owned === 0 || !logged()) return;
    autoCollectDone = true;
    var off = false;
    try { off = localStorage.getItem(PREF_KEY) === '1'; } catch (e) {}
    if (!off && !collectOn()) { clickSwitch('.lz-collection-switch'); setTimeout(render, 50); }
  }
  bar.addEventListener('click', function (e) {
    var b = e.target.closest('[data-act="collect"]');
    if (!b) return;
    try { if (collectOn()) localStorage.setItem(PREF_KEY, '1'); else localStorage.removeItem(PREF_KEY); } catch (er) {}
  }, true);

  var pending = null;
  function schedule() {
    clearTimeout(pending);
    pending = setTimeout(function () { render(); injectBells(); autoCollect(); applySearch(); }, 120);
  }
  document.addEventListener('lz:mc:state', schedule);
  // Filet de sécurité si un traqueur n'émet pas l'événement : on observe la grille.
  // On ignore nos propres modifications (bande, cloches, boutons +, bandeau
  // d'import, masquage par la recherche), sinon chaque rendu en déclencherait un autre.
  var OURS = '.lzmc-bell, .lzmc-import, .lzmc-pick';
  function isOurs(node) {
    var el = node && (node.nodeType === 1 ? node : node.parentElement);
    return !!el && (bar.contains(el) || !!el.closest(OURS));
  }
  function classKey(s) {
    return (s || '').split(/\s+/).filter(function (c) { return c && c !== FIND_HIDE; }).sort().join(' ');
  }
  function relevant(rec) {
    if (isOurs(rec.target)) return false;
    if (rec.type === 'attributes' && rec.attributeName === 'class' && classKey(rec.oldValue) === classKey(rec.target.getAttribute('class'))) return false;
    if (rec.type === 'childList') {
      var nodes = Array.prototype.slice.call(rec.addedNodes).concat(Array.prototype.slice.call(rec.removedNodes));
      if (nodes.length && nodes.every(function (n) { return n.nodeType === 1 && n.classList && (n.classList.contains('lzmc-bell') || n.classList.contains('lzmc-import') || n.classList.contains('lzmc-pick')); })) return false;
    }
    return true;
  }
  // Cartes ajoutées par le préchargement des pages suivantes : la recherche en
  // cours s'y applique aussitôt, avant leur affichage (pas après le délai du rendu).
  function addsCards(rec) {
    return rec.type === 'childList' && Array.prototype.some.call(rec.addedNodes, function (n) {
      return n.nodeType === 1 && (n.classList.contains('rzc-item') || !!n.querySelector('.rzc-item'));
    });
  }
  if ('MutationObserver' in window) {
    new MutationObserver(function (recs) {
      if (findOn() && recs.some(addsCards)) applySearch();
      if (recs.some(relevant)) schedule();
    }).observe(root, { subtree: true, attributes: true, attributeOldValue: true, attributeFilter: ['class', 'data-owned'], childList: true });
  }
  // L'ancien bouton groupé du panneau flottant ajoute TOUTES les versions
  // manquantes (reverse, Pokéball, Masterball…). On le renomme pour qu'il ne soit
  // pas confondu avec « Compléter la série » de la bande (version principale).
  root.querySelectorAll('.rzc-bulk.is-all .rzc-bulk-title').forEach(function (t) {
    t.textContent = 'Toutes les versions manquantes';
  });

  var filterWasOpen = root.classList.contains('lz-filter-open');
  if ('MutationObserver' in window) {
    new MutationObserver(function () {
      var open = root.classList.contains('lz-filter-open');
      if (open === filterWasOpen) return;
      filterWasOpen = open;
      var fc = view.querySelector('[data-act="filters"]');
      if (fc) fc.setAttribute('aria-expanded', String(open));
      var panel = root.querySelector('#lz-filter-panel');
      if (!open && fc && (document.activeElement === document.body || (panel && panel.contains(document.activeElement)))) fc.focus({ preventScroll: true });
    }).observe(root, { attributes: true, attributeFilter: ['class'] });
  }

  render();
  injectBells();
  loadWishlist();
  offerImport();

  // Lien « Voir ce qui me manque » (encart fiche carte, tableau de bord) :
  // /collections/<série>?lzmc=manquantes active le filtre dès que l'état est connu.
  try {
    var want = new URLSearchParams(window.location.search).get('lzmc');
    if (want === 'manquantes') {
      var applied = false;
      var applyMissing = function () {
        if (applied || !last || last.owned === 0) return;
        applied = true;
        if (!missingOn()) clickSwitch('.lz-missing-switch');
        setTimeout(function () { render(); bar.scrollIntoView({ block: 'start' }); }, 80);
      };
      document.addEventListener('lz:mc:state', function () { setTimeout(applyMissing, 200); });
      setTimeout(applyMissing, 1500);
    }
  } catch (e) {}
})();
